

const globalColors = {
  "primaryColor"  : "#18332B",
  "primaryText"   : "#FFFFFF",
  "secondaryColor": "#517266",
  "secondaryText" : "#FFFFFF",
  "ctaPrimary"    : "#A47D2D",
  "ctaText"       : "#FFFFFF"
};

export default globalColors;